import {
  getListProblem,
  deleteProblem,
  createProblem,
  editProblem,
  getDetailProblem,
  getNewProblem
} from "../api.js";

export const state = {
  problemsResponse: {},
  deleteProblemResponse: {},
  createProblemResponse: {},
  editProblemResponse: {},
  getDetailProblemResponse: {},
  getNewProblemResponse: {}
};

export const getters = {
  problemsResponse: state =>
    state.problemsResponse ? state.problemsResponse.data : [],
  pagination: state => (state.problemsResponse ? state.problemsResponse : {}),
  createProblemResponse: state =>
    state.createProblemResponse ? state.createProblemResponse.data : [],
  editProblemResponse: state =>
    state.editProblemResponse ? state.editProblemResponse.data : [],
  getDetailProblemResponse: state =>
    state.getDetailProblemResponse ? state.getDetailProblemResponse : [],
  getNewProblemResponse: state =>
    state.getNewProblemResponse ? state.getNewProblemResponse : []
};

export const mutations = {
  getList(state, data) {
    state.problemsResponse = data.data;
  },

  delete(state, data) {
    state.deleteProblemResponse = data.data;
  },

  create(state, data) {
    if (!data.error) {
      state.createProblemResponse = data.data;
    } else {
      state.createProblemResponse = data.error.response.data;
    }
  },

  getDetail(state, data) {
    state.getDetailProblemResponse = data.data;
  },

  edit(state, data) {
    if (!data.error) {
      state.editProblemResponse = data.data;
    } else {
      state.editProblemResponse = data.error.response.data.code;
    }
  },

  getNew(state, data) {
    state.getNewProblemResponse = data.data;
  }
};

export const actions = {
  async getList({ commit }, query) {
    let data = await getListProblem(query);
    commit("getList", data);
  },

  async delete({ commit }, query) {
    let data = await deleteProblem(query);
    commit("delete", data);
  },

  async create({ commit }, query) {
    let data = await createProblem(query);
    commit("create", data);
  },

  async edit({ commit }, query) {
    let data = await editProblem(query);
    commit("edit", data);
  },

  async getDetail({ commit }, query) {
    let data = await getDetailProblem(query);
    commit("getDetail", data);
  },

  async getNew({ commit }) {
    let data = await getNewProblem();
    commit("getNew", data);
  }
};
